/**
 * NewsletterPromo Component
 */

import { FieldEmail } from '../../../../redux/form/utils';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { findDOMNode } from 'react-dom';
import * as WindowSizeListener from 'react-window-size-listener';
import { FormProps, reduxForm } from 'redux-form';

import { VelocityComponent, VelocityTransitionGroup } from 'velocity-react';
import { sendNewsletterSignup } from '../../../../pardot/actions';
import Button from '../../../atoms/buttons/Button';
import LinkButton from '../../../atoms/buttons/LinkButton';
import TextField from '../../../atoms/forms/TextField';
import { IconMail } from '../../../atoms/images/Icon';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import { SignupPagePath } from '../../../pages/account/Login';

interface IFormFields {
  email: string;
}

interface NewsletterPromoProps extends FormProps<IFormFields, undefined, undefined> {
  isUserLoggedIn: boolean;
}

const classes = new BEM('newsletter-promo');

class NewsletterPromo extends React.Component<NewsletterPromoProps, {}> {
  element: HTMLDivElement | null;
  image: HTMLImageElement;
  setParallaxLimitTimer: number;

  clientRect: ClientRect;
  parallaxStartPosition: number;
  parallaxEndPosition: number;
  parallaxLimit: number;

  setParallaxLimit() {
    if (this.image) {
      const { height } = this.image.getBoundingClientRect();
      if (!height) {
        this.setParallaxLimitTimer = window.setTimeout(() => {
          this.setParallaxLimit();
        }, 100);
      } else {
        this.parallaxLimit = height - this.clientRect.height;
      }
    }
  }

  componentDidMount() {
    this.element = findDOMNode(this) as HTMLDivElement;
    this.initParallaxEffect();
    window.addEventListener('scroll', this.onScroll);
  }

  componentWillUnmount() {
    window.clearTimeout(this.setParallaxLimitTimer);
    window.removeEventListener('scroll', this.onScroll);
    this.element = null;
  }

  onResize = () => {
    this.initParallaxEffect();
    this.onScroll();
  }

  onScroll = () => {
    const st = window.scrollY;
    if (st > this.parallaxStartPosition
      && st < this.parallaxEndPosition) {
      const factor = st / this.parallaxEndPosition;
      this.image.style.transform = `translate3d(-50%, ${-this.parallaxLimit * factor}px, 0)`;
    }
  }

  render() {
    return (
      <form onSubmit={this.props.handleSubmit} {...classes()}>
        <div {...classes('wrapper')}>
          <div {...classes('background')}>
            <img
              ref={(node) => this.image = node!}
              src="https://orpheus-assets.s3.amazonaws.com/homepage/headphones.jpg"
              alt="A pair of headphones on a yellow background"
            />
          </div>
          <VelocityTransitionGroup
            component="div"
            enter={{ animation: 'transition.slideUpIn', duration: 500, delay: 500 }}
            leave={{ animation: 'transition.slideUpOut', duration: 500 }}
            {...classes('content-wrapper', '', 'container')}
          >
            {this.props.submitSucceeded ? (
              // tslint:disable:max-line-length
              <div key="success-message" {...classes('content')}>
                <Heading is="h3" {...classes('title')}>Great Stuff.</Heading>
                <Heading is="h4">
                Check your inbox for an introduction to the Music Discovery Club!
                </Heading>
                {
                  !this.props.isUserLoggedIn ? (
                    <div {...classes('create-account')}>
                      <LinkButton to={SignupPagePath} label="Create an account" colorScheme="dark" size="medium" />
                      &nbsp;
                      <Span variant="description" size="large">to save tracks to Playlists.</Span>
                    </div>
                    ) : ''
                }
              </div>
              // tslint:enable:max-line-length
            ) : (
                <div key="form" {...classes('content')}>
                  <Heading is="h3" {...classes('title')}>
                  Sign up to the Music Discovery Club to receive trending music in your inbox every two weeks.
                  </Heading>
                  <VelocityComponent animation={this.props.submitFailed ? 'callout.shake' : { opacity: 1 }}>
                    <FieldEmail
                      component={TextField}
                      name="email"
                      inlineButton={<Button label="Submit" colorScheme="dark" size="medium" isSubmit />}
                      icon={<IconMail />}
                      placeholder="Your email"
                      colorScheme="white"
                      {...classes('textfield')}
                      onlyValidateIfTouched
                      withoutBorder
                    />
                  </VelocityComponent>
                </div>
              )}
          </VelocityTransitionGroup>
        </div>
        <WindowSizeListener onResize={this.onResize} />
      </form>
    );
  }

  initParallaxEffect() {
    this.clientRect = this.element!.getBoundingClientRect();
    const { height } = this.clientRect;
    this.parallaxStartPosition = this.element!.offsetTop - window.innerHeight;
    this.parallaxEndPosition = this.parallaxStartPosition + height * 2 + (window.innerHeight - height);
    this.setParallaxLimit();
  }
}

const NewsletterPromoForm = reduxForm<IFormFields, {}, {}>({
  form: 'newsletter-signup',
  onSubmit: ({ email }, dispatch) => {
    dispatch(sendNewsletterSignup({ email }));
  },
})(NewsletterPromo);

export default NewsletterPromoForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/NewsletterPromo/index.tsx